import { IDs } from '../../../helpers/IDs';
import { StructureService } from '../../../services/structure_service';

function getAttributes(entity: string): any[] {
    return ((((StructureService || {}).structures || {})[IDs.MOD_ETOOL] || {})[entity] || {}).ATTS || [];
}

function getConfigByExclusion(keys: string[], params: any, entity: string): any {
    const atts: any[] = getAttributes(entity);
    const config: any = {};

    atts.forEach((att: any) => {
        const key: string = att.KEY || att.ID || null;

        if ((keys || []).indexOf(key) !== -1) {
            return;
        }
        config[key] = params || {};
    });

    return config;
}

export function getCustomFormConfigVsme(entity: string, item: any, data: any, contextKey?: string, filter?: any): any {
    let config: any = {};
    data = data || {};
    filter = filter || {};
    item = item || {};
    const variante: string = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).dateneingabe_variante || null;

    switch (entity) {
        case IDs.ENT_BETRIEBSDATEN:
            if (variante !== 'vsme') {
                break;
            }
            const exclusion: string[] = contextKey === 'vsme_bpm'
                ? ['anz_auzubildende']
                : ['anz_auzubildende', 'anz_mitarbeiter', 'anz_mitarbeiter_real', 'anz_praktikanten'];
            return getConfigByExclusion(exclusion, { hidden: true }, entity);
        case IDs.ENT_KONFIGURATION:
            if (variante !== 'vsme') {
                break;
            }
            return getConfigByExclusion(['berater_zugriff', 'externer_berater'], { hidden: true }, entity);
        case IDs.ENT_ENERGIEDATEN_WASSER:
            config.rueckerstattung = { hidden_input: true };
            break;
        case IDs.ENT_VSME_B3:
            if (!item.tid || isJa('e_tool_nutzung', item)) {
                config.energieverbrauch = { hidden: true };
                config.strom = { hidden_input: true };
                config.fossile_brennstoffe = { hidden_input: true };
                config.scopes = { hidden: true };
                config.scope1 = { hidden_input: true };
                config.scope2 = { hidden_input: true };
                config.dokumente = { hidden: true };
            }
            break;
        case IDs.ENT_VSME_B5:
            const jahr: number = item.jahr || null;
            if (isNein('schutzgebiet', item)) {
                config.grundstuecksflaeche = { hidden_input: true };
            }
            if (typeof jahr === 'number') {
                const labels: any = {};
                getAttributes(entity).forEach((item: any) => labels[item.KEY] = item.NAME || item.ID || null);
                const getLabel = (key: string, value: number) => typeof labels[key] === 'string'
                    ? { label: `${labels[key]} (${value})` } : {};
                ['jahr_flaeche_nutzung', 'jahr_flaeche_versiegelt', 'jahr_flaeche_naturnah_standort', 'jahr_flaeche_naturnah_ausserhalb']
                    .forEach((key: string) => config[key] = { ...getLabel(key, jahr) });
                ['vorjahr_flaeche_nutzung', 'vorjahr_flaeche_versiegelt', 'vorjahr_flaeche_naturnah_standort', 'vorjahr_flaeche_naturnah_ausserhalb']
                    .forEach((key: string) => config[key] = { ...getLabel(key, jahr - 1) });
            }
            if (!item.tid) {
                config.dokumente = { hidden: true };
            }
            break;
        case IDs.ENT_VSME_B7:
            if (isNein('unternehmensverfahren', item)) {
                config.recycling_anteil = { hidden_input: true };
                config.verwertbare_stoffe_anteil = { hidden_input: true };
            }
            if (!item.tid) {
                config.dokumente = { hidden: true };
            }
            break;
        case IDs.ENT_VSME_B9:
            const checkView: number[] = [1, 1];
            if (isNein('arbeitsunfaelle', item)) {
                config.arbeitsunfaelle_anzahl = { hidden_input: true };
                checkView[0] = 0;
            }
            if (isNein('todesfaelle', item)) {
                config.todesfaelle_verletzungen = { hidden_input: true };
                config.todesfaelle_erkrankungen = { hidden_input: true };
                checkView[1] = 0;
            }
            if (!checkView.reduce((a: number, b: number) => a + b, 0)) {
                config.dokumente = { hidden: true };
                config.bemerkung = { hidden: true };
            }
            if (!item.tid) {
                config.dokumente = { hidden: true };
            }
            break;
        case IDs.ENT_VSME_B10: {
            const betriebsdaten: any = (data[IDs.ENT_BETRIEBSDATEN] || [])
                .find((bd: any) => bd.jahr === filter.jahr && bd.standort_tid_orig === filter.standort_tid) || {};
            if ((+betriebsdaten.anz_mitarbeiter_real || 0) < 150) {
                config.lohn_maennlich = { hidden_input: true };
                config.lohn_weiblich = { hidden_input: true };
                config.lohn_divers = { hidden_input: true };
            }
            if (!item.tid) {
                config.dokumente = { hidden: true };
            }
            break;
        }
        case IDs.ENT_VSME_B11:
            if (isNein('unternehmensprozesse', item)) {
                config.prozess = { hidden_input: true };
                config.auswirkungen = { hidden_input: true };
                config.betroffene_orte = { hidden_input: true };
                config.betroffene_gruppen = { hidden_input: true };
                config.dokumente = { hidden_input: true };
                config.bemerkung = { hidden_input: true };
            }
            if (!item.tid) {
                config.dokumente = { hidden: true };
            }
            break;
        case IDs.ENT_VSME_B12:
            if (isNein('verurteilungen_geldbussen', item)) {
                config.verurteilungen = { hidden_input: true };
                config.geldbussen = { hidden_input: true };
                config.dokumente = { hidden_input: true };
                config.bemerkung = { hidden_input: true };
            }
            if (!item.tid) {
                config.dokumente = { hidden: true };
            }
            break;
        case IDs.ENT_VSME_B1:   // no break
        case IDs.ENT_VSME_B2:   // no break
        case IDs.ENT_VSME_B4:   // no break
        case IDs.ENT_VSME_B6:   // no break
        case IDs.ENT_VSME_B8:   // no break
            if (!item.tid) {
                config.dokumente = { hidden: true };
            }
            break;
        case IDs.ENT_VSME_BPM1:
            if (isNein('umstrittene_waffen', item)) {
                config.umstrittene_waffen_einkuenfte = { hidden_input: true };
            }
            if (isNein('tabak', item)) {
                config.tabak_einkuenfte = { hidden_input: true };
            }
            if (isNein('fossile_brennstoffe', item)) {
                config.kohle_einkuenfte = { hidden_input: true };
                config.oel_einkuenfte = { hidden_input: true };
                config.gas_einkuenfte = { hidden_input: true };
            }
            if (isNein('chemikalien', item)) {
                config.chemikalien_einkuenfte = { hidden_input: true };
            }
            break;
        case IDs.ENT_VSME_BPM3:
            if (isNein('ziele', item)) {
                config.titel_scope1 = {
                    disableExtraElement: true,
                    hidden: true
                };
                config.titel_scope2 = {
                    disableExtraElement: true,
                    hidden: true
                };
            }
            break;
        case IDs.ENT_VSME_BPM4:
            if (isNein('uebergangsplan', item)) {
                config.massnahmen = { hidden_input: true };
            }
            break;
        case IDs.ENT_VSME_BPM5:
            if (isNein('physikalische_risiken', item)) {
                config.titel_a = { hidden: true };
                config.gesamtvermoegensanteil_kurz = { hidden: true };
                config.gesamtvermoegensanteil_kurz_akut_euro = { hidden_input: true };
                config.gesamtvermoegensanteil_kurz_akut_prozent = { hidden_input: true };
                config.gesamtvermoegensanteil_kurz_chronisch_euro = { hidden_input: true };
                config.gesamtvermoegensanteil_kurz_chronisch_prozent = { hidden_input: true };
                config.gesamtvermoegensanteil_mittel = { hidden: true };
                config.gesamtvermoegensanteil_mittel_akut_euro = { hidden_input: true };
                config.gesamtvermoegensanteil_mittel_akut_prozent = { hidden_input: true };
                config.gesamtvermoegensanteil_mittel_chronisch_euro = { hidden_input: true };
                config.gesamtvermoegensanteil_mittel_chronisch_prozent = { hidden_input: true };
                config.gesamtvermoegensanteil_lang = { hidden: true };
                config.gesamtvermoegensanteil_lang_akut_euro = { hidden_input: true };
                config.gesamtvermoegensanteil_lang_akut_prozent = { hidden_input: true };
                config.gesamtvermoegensanteil_lang_chronisch_euro = { hidden_input: true };
                config.gesamtvermoegensanteil_lang_chronisch_prozent = { hidden_input: true };
                config.titel_b = { hidden: true };
                config.gesamtvermoegensanteil_euro = { hidden_input: true };
                config.gesamtvermoegensanteil_prozent = { hidden_input: true };
                config.titel_c = {
                    disableExtraElement: true,
                    hidden: true
                };
                config.titel_d = { hidden: true };
                config.einnahmensanteil_kurz = { hidden: true };
                config.einnahmensanteil_kurz_netto_euro = { hidden_input: true };
                config.einnahmensanteil_kurz_netto_prozent = { hidden_input: true };
                config.einnahmensanteil_mittel = { hidden: true };
                config.einnahmensanteil_mittel_netto_euro = { hidden_input: true };
                config.einnahmensanteil_mittel_netto_prozent = { hidden_input: true };
                config.einnahmensanteil_lang = { hidden: true };
                config.einnahmensanteil_lang_netto_euro = { hidden_input: true };
                config.einnahmensanteil_lang_netto_prozent = { hidden_input: true };
                config.titel_e = {
                    disableExtraElement: true,
                    hidden: true
                };
            }
            break;
        case IDs.ENT_VSME_BPM6:
            if (isNein('gefaehrliche_radioaktive_abfaelle', item)) {
                config.radioaktiver_abfall = { hidden_input: true };
                config.gefahrstoffe = { hidden_input: true };
            }
            break;
        case IDs.ENT_VSME_N3:
            if (isNein('strategien_massnahmen', item)) {
                config.info_strategien = { hidden_input: true };
                config.info_massnahmen = { hidden_input: true };
            }
            break;
    }

    return config;
}

function isJa(key: string, data: any): boolean {
    return (+data[`${key}_orig`] || +data[key]) === 1 || data[key] === 'Ja';
}

function isNein(key: string, data: any): boolean {
    return [0, 2].indexOf(+data[`${key}_orig`] || +data[key] || 0) !== -1 || data[key] === 'Nein';
}
